<ng-container *ngIf="hasVisibleItems">
  <p-menu
    #menu
    [model]="menuItems"
    [popup]="true"
    appendTo="body"
    [baseZIndex]="9000"
    styleClass="action-menu__popup">
    <ng-template #item let-item>
      <span
        [pTooltip]="item.data?.tooltip"
        [tooltipDisabled]="!item.data?.tooltip"
        tooltipPosition="left"
        style="display: block; pointer-events: auto;">
        <a
          class="p-menu-item-link"
          [class.p-disabled]="item.disabled"
          [style.pointer-events]="item.disabled ? 'none' : null">
          <i *ngIf="item.icon" [class]="item.icon + ' p-menu-item-icon'"></i>
          <span class="p-menu-item-label">{{ item.label }}</span>
        </a>
      </span>
    </ng-template>
  </p-menu>
  <button
    type="button"
    class="action-menu__trigger d-inline-flex align-items-center justify-content-center p-0 bg-transparent rounded-3"
    (click)="onToggle($event); $event.stopPropagation()">
    <i class="pi pi-bars action-menu__trigger-icon" aria-hidden="true"></i>
  </button>
</ng-container>
